export const getEmptyImageSelector = store => store.locationReducer.emptyImage;

export const getLanguageSelector = store => store.locationReducer.language;